import type { SelectOption, OrganizationsData } from '../../common/types.tsx';

export const mapOrganizationOptionsToData = (options: SelectOption[]): number[] =>
	options.map(({ value }) => Number.parseInt(value, 10));

export const mapDataToOrganizationOptions = (data: OrganizationsData): SelectOption[] =>
	data.map(({ id, name }) => ({
		label: name,
		value: `${id}`, // the AK Select component options require string values
	}));
